/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type admin_RunSeedsRequest = {
    operation: admin_RunSeedsRequest.operation;
    services: Array<string>;
};
export namespace admin_RunSeedsRequest {
    export enum operation {
        SEED = 'seed',
        RESET = 'reset',
        RESET_AND_SEED = 'reset_and_seed',
    }
}

